import { Query } from "src/app/shared/ddd/models/query";

export class ScopeOfWorkQuery implements Query {
  inspectionId: string;

  constructor(inspectionId: string) {
    this.inspectionId = inspectionId;
  }
}
